// extracted by mini-css-extract-plugin
export default {"talent":"talent_talent__frgSf","btn4":"talent_btn4__ICYvF"};